// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".promoSectionTitle__sY9zM{padding:20px 20px 0 20px;text-align:center;height:40px}.promoSectionTitle__sY9zM.small__1NUSN{padding:10px 20px 0;height:auto}.promoAsterisk__1FKRk{margin:20px 20px 60px 20px}\n", "",{"version":3,"sources":["/home/runner/work/honeylove-web/honeylove-web/src/cart/components/CartPromoList.module.scss"],"names":[],"mappings":"AAAA,0BACE,wBAAyB,CACzB,iBAAkB,CAClB,WAAY,CAHd,uCAMI,mBAAoB,CACpB,WAAY,CACb,sBAID,0BAA2B","file":"CartPromoList.module.scss","sourcesContent":[".promoSectionTitle {\n  padding: 20px 20px 0 20px;\n  text-align: center;\n  height: 40px;\n\n  &.small {\n    padding: 10px 20px 0;\n    height: auto;\n  }\n}\n\n.promoAsterisk {\n  margin: 20px 20px 60px 20px;\n}\n"]}]);
// Exports
exports.locals = {
	"promoSectionTitle": "promoSectionTitle__sY9zM",
	"small": "small__1NUSN",
	"promoAsterisk": "promoAsterisk__1FKRk"
};
module.exports = exports;
